export class AnnualRecallPhonelist {
    client_no: number
    pet_name: string
    last_name: string
    first_name: string
    address: string
    city: string
    state: string
    zip: string
    zip4: string
    brief_hist_code: string
    brief_hist_date: string
    pet_code: string
    client_code: string
    home_phone: string

    constructor(
        client_no: number,
        pet_name: string,
        last_name: string,
        first_name: string,
        address: string,
        city: string,
        state: string,
        zip: string,
        zip4: string,
        brief_hist_code: string,
        brief_hist_date: string,
        pet_code: string,
        client_code: string,
        home_phone: string,
    ) {
        this.client_no = client_no
        this.pet_name = pet_name
        this.last_name = last_name
        this.first_name = first_name
        this.address = address
        this.city = city
        this.state = state
        this.zip = zip
        this.zip4 = zip4
        this.brief_hist_code = brief_hist_code
        this.brief_hist_date = brief_hist_date
        this.pet_code = pet_code
        this.client_code = client_code
        this.home_phone = home_phone 
    }
}
//client_no	pet_name	last_name	first_name	address	city	state	zip	zip4	brief_hist_code	brief_hist_date	pet_code	client_code	home_phone